import Control from "ol/control/Control";
import Vector from "ol/source/Vector";
import Snap from "ol/interaction/Snap";

export const currentLayer = Symbol("currentLayer");
export const source = Symbol("source");
export const snapInteraction = Symbol("snapInteraction");
export const map = Symbol("map");
export const editor = Symbol("editor");
export const active = Symbol("active");
export const interaction = Symbol("interaction");

export class BaseAnnotationControl extends Control {
  constructor(options) {
    super({ element: options.element, target: options.target });
    this[currentLayer] = options.layer;
    this[source] =
      options.source ||
      new Vector({
        // features: options.features
      });
    this[snapInteraction] = new Snap({
      source: this[source]
    });
  }

  setMap(mapVal) {
    this[map] = mapVal;
    super.setMap(mapVal);
  }

  setTarget(target) {
    // this[map] = target;
    super.setTarget(target);
  }

  set interaction(interactionVal) {
    this[interaction] = interactionVal;
  }

  get interaction() {
    return this[interaction];
  }

  setEditor(editor) {
    this[editor] = editor;
  }

  activate() {
    this[active] = true;
    if (this[interaction]) {
      this[map].addInteraction(this[interaction]);
    }
    // this.element.className += ' active';
    // this[editor].activeStateChange(this);
    // console.log('snap', this[snapInteraction]);
    // this[map].addInteraction(this[snapInteraction]);
  }

  deactivate() {
    this[active] = false;
    if (this[interaction]) {
      this[map].removeInteraction(this[interaction]);
    }
    // this[editor].activeStateChange(this);
    this[map].getViewport().style.cursor = "-webkit-grab";
    // this[map].removeInteraction(this.snapInteraction);
  }

  get active() {
    return this[active];
  }

  get map() {
    return this[map];
  }

  get source() {
    return this[source];
  }
}
